module.exports = __webpack_public_path__ + "static/media/29EUNOG19.1f4a21cc.jpg";